import type { SqlDiskSku, SqlVmLimits } from '@/types/infrastructure'

/**
 * Azure managed disk sizes with their performance, as Azure publishes them. The mock infrastructure service returns these
 * as the SQL storage options; a real API would return the same shape for the region.
 */
const sku = (id: string, diskType: SqlDiskSku['diskType'], sizeGb: number, maxIops: number, maxThroughputMbps: number): SqlDiskSku => ({
  id,
  diskType,
  sizeGb,
  maxIops,
  maxThroughputMbps,
})

export const AZURE_DISK_SKUS: SqlDiskSku[] = [
  sku('P10', 'Premium SSD', 128, 500, 100),
  sku('P15', 'Premium SSD', 256, 1100, 125),
  sku('P20', 'Premium SSD', 512, 2300, 150),
  sku('P30', 'Premium SSD', 1024, 5000, 200),
  sku('P40', 'Premium SSD', 2048, 7500, 250),
  sku('P50', 'Premium SSD', 4096, 7500, 250),
  sku('P60', 'Premium SSD', 8192, 16000, 500),
  sku('P70', 'Premium SSD', 16384, 18000, 750),
  sku('P80', 'Premium SSD', 32767, 20000, 900),
  sku('E10', 'Standard SSD', 128, 500, 60),
  sku('E15', 'Standard SSD', 256, 500, 60),
  sku('E20', 'Standard SSD', 512, 500, 60),
  sku('E30', 'Standard SSD', 1024, 500, 60),
  sku('E40', 'Standard SSD', 2048, 500, 60),
  sku('E50', 'Standard SSD', 4096, 500, 60),
  sku('E60', 'Standard SSD', 8192, 2000, 400),
  sku('E70', 'Standard SSD', 16384, 4000, 600),
  sku('E80', 'Standard SSD', 32767, 6000, 750),
]

/** The VM the mock recommends for a SQL server, with the limits that apply to all of its disks together. */
export const DEFAULT_SQL_VM: SqlVmLimits = {
  vmSize: 'Standard_E16ds_v4',
  maxIops: 25600,
  maxThroughputMbps: 384,
  maxDataDisks: 32,
  recommendedDiskType: 'Premium SSD',
}
